import { doc, updateDoc, getDoc, getFirestore, increment } from "firebase/firestore";
import app from "./firebase.config";

const db = getFirestore(app);

function simpleHash(str) {
  const normalized = str.toLowerCase().trim();
  let hash = 0;
  for (let i = 0; i < normalized.length; i++) {
    hash = (hash << 5) - hash + normalized.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }
  return hash;
}

export const addEmailToList = async (email) => {
  // Basic email validation
  if (!email.includes("@") || !email.includes(".")) {
    return { 
      success: false, 
      message: "That didn't quite work. Try again." 
    };
  }

  const emailDoc = doc(db, "emailList", "emailList");
  const campusDoc = doc(db, "campusList", "campusList");
  const emailHash = simpleHash(email);

  try {
    // Check if email already exists
    const emailSnapshot = await getDoc(emailDoc);
    if (emailSnapshot.exists() && emailSnapshot.data()[emailHash]) {
      return { 
        success: false, 
        message: "You're already on the list!" 
      };
    }

    // Add email to list first
    await updateDoc(emailDoc, {
      [emailHash]: { email: email }
    });

    // Try to update campus count
    try {
      const domain = email.split("@")[1].toLowerCase();
      const domainHash = simpleHash(domain);
      
      const campusSnapshot = await getDoc(campusDoc);
      if (campusSnapshot.exists() && campusSnapshot.data()[domainHash]) {
        await updateDoc(campusDoc, {
          [`${domainHash}.signupCount`]: increment(1)
        });
      } else {
        await updateDoc(campusDoc, {
          [domainHash]: {
            domain: domain,
            signupCount: 1,
            showOnWebsite: false
          }
        });
      }
    } catch (campusError) {
      console.error("Campus update failed:", campusError);
    }

    return { 
      success: true, 
      message: "Great. You're on the list." 
    };

  } catch (error) {
    console.error("Email signup error:", error);
    return { 
      success: false, 
      message: "That didn't quite work. Try again." 
    };
  }
};